export default __webpack_public_path__ + "ff10550ffcb5e2e6e9227329fa43329e.svg";